import { render, staticRenderFns } from "./ReferenceFeed.vue?vue&type=template&id=010e1df3&scoped=true&"
import script from "./ReferenceFeed.vue?vue&type=script&lang=js&"
export * from "./ReferenceFeed.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceFeed.vue?vue&type=style&index=0&id=010e1df3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010e1df3",
  null
  
)

export default component.exports